export const CART_ITEMS_LIST = "CART_ITEMS_LIST"
export const ADD_CART_ITEM = "ADD_CART_ITEM"
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM"
export const DELETE_CART_ITEM = "DELETE_CART_ITEM"
export const CLEAR_CART = "CLEAR_CART"
